import * as React from 'react';
import { IORef } from 'fp-ts/lib/IORef';

const instance = new IORef([] as ReadonlyArray<string | number>);

const Context = React.createContext(instance);

export const Provider: React.FunctionComponent = ({ children }) => {
    return (
        <Context.Provider value={instance}>
            {children}
        </Context.Provider>
    );
}

export const useContext = () => {
    const ctx = React.useContext(Context);
    return ctx;
}

type Id = number | string;

export const useStacked = (showed: boolean, id: Id) => {
    const stack = useContext();

    React.useEffect(() => {
        if(showed){
            stack.modify(xs => [id, ...xs])();
        }
        else {
            const currentStackState = stack.read();
            const index = currentStackState.findIndex(x => x === id);

            stack.modify(xs => xs.slice(index + 1))();
        }
    }, [showed]);
}

export const useRunned = (id: Id) => {
    const stack = useContext();

    return (fn: () => void) => {
        const pop = stack.read()[0];

        if(pop === id){
            fn();
        }
    }
}
